module.exports = __webpack_public_path__ + "static/media/card-game-prize.2f0dea3c.png";